import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyProps } from '../shared/js';
import styles from './nav.module.scss';

const NavDrawer = ({ isOpen, onClose, children, ...props }) => (
  <div
    className={cn(styles.navDrawer, { [styles.navOpen]: isOpen })}
    {...applyProps(props)}
  >
    {children}
    {isOpen && <div className={styles.drawerOverlay} onClick={onClose} />}
  </div>
);

NavDrawer.propTypes = {
  /** A prop indicating whether or not the drawer is open */
  isOpen: PropTypes.any,
  /** A callback function called when the drawer is closed */
  onClose: PropTypes.func,
  /** A component or element to be used as the logo */
  children: PropTypes.any,
  /** A style object forwarded to the logo's wrapping element */
  style: PropTypes.any,
  /** A class name forwarded to the logo's wrapping element */
  className: PropTypes.string,
};

NavDrawer.defaultProps = {
  isOpen: false,
  onClose: undefined,
  children: undefined,
  style: undefined,
  className: undefined,
};

export default NavDrawer;
